document.addEventListener("DOMContentLoaded", function () {
    const cards = document.querySelectorAll(".video-card");
    const searchInput = document.getElementById("videoSearch");
    const videoGrid = document.getElementById("videoGrid");
    const videoDetail = document.getElementById("videoDetail");
    const videoMain = videoDetail.querySelector(".video-main");
    const videoInfo = videoDetail.querySelector(".video-info");
    const videoProduct = videoDetail.querySelector(".video-product");
    const sidebarCards = document.querySelectorAll(".video-sidebar-card");

    const urlParams = new URLSearchParams(window.location.search);
    const activeVideo = urlParams.get("video");

    function renderVideo(card) {
        if (!card) return;
        const yt = card.dataset.youtube.split("youtu.be/")[1];
        const iframe = `<iframe width="100%" height="480" src="https://www.youtube.com/embed/${yt}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
        videoMain.innerHTML = iframe;
        videoInfo.innerHTML = `<h1>${card.dataset.title}</h1><p>${card.dataset.description}</p>`;
        videoDetail.style.display = "block";
        const productHtml = card.querySelector(".hidden-products")?.innerHTML || "";
        if(/[a-zA-Z]/.test(productHtml)){
        videoProduct.innerHTML = productHtml
            ? `<div class="may-like-block__title block-heading h2"><h2>Featured Products</h2></div>
     <div class="product-carousel js-flickity"
       data-flickity='{ "cellAlign": "left", "contain": true, "wrapAround": false, "pageDots": false }'>
         ${productHtml}
     </div>`
            : "";
        }else{
            videoProduct.innerHTML = '';
        }

        const observer = new MutationObserver(() => {
            const carouselEl = document.querySelector('.product-carousel');
            if (carouselEl && carouselEl.offsetParent !== null && !carouselEl.classList.contains('flickity-enabled')) {
                new Flickity(carouselEl, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    pageDots: false
                });
                observer.disconnect();
            }
        });

        observer.observe(videoProduct, { childList: true, subtree: true });


        sidebarCards.forEach(sc => {
            sc.classList.remove("active");
            if (sc.dataset.videoId === card.dataset.videoId) {
                sc.classList.add("active");
            }
        });
        if (window.Flickity) {
            const carouselEl = document.querySelector('.product-carousel');
            if (carouselEl && !carouselEl.classList.contains('flickity-enabled')) {
                new Flickity(carouselEl, {
                    "wrapAround": false,
                    "prevNextButtons": true,
                    "contain": false,
                    "cellAlign": "left",
                    "pageDots": false
                });
            }
        }
    }

    if (activeVideo) {
        const card = document.querySelector(`[data-video-id="${activeVideo}"]`);
        if (card) {
            renderVideo(card);
            if (window.Flickity) {
                const carouselEl = document.querySelector('.product-carousel');
                if (carouselEl && !carouselEl.classList.contains('flickity-enabled')) {
                    new Flickity(carouselEl, {
                        "wrapAround": false,
                        "prevNextButtons": true,
                        "contain": false,
                        "cellAlign": "left",
                        "pageDots": false
                    });
                }
            }
            videoGrid.style.display = "none";

        }
    }

    if (searchInput) {
        searchInput.addEventListener("input", function () {
            const term = this.value.toLowerCase();
            cards.forEach(card => {
                const title = card.getAttribute("data-title").toLowerCase();
                const description = card.getAttribute("data-description").toLowerCase();
                const match = title.includes(term) || description.includes(term);
                card.style.display = match ? "block" : "none";
            });
        });
    }

    cards.forEach(card => {
        card.addEventListener("click", function () {
            const id = card.getAttribute("data-video-id");
            window.location.href = `?video=${id}`;
        });
    });

    sidebarCards.forEach(sideCard => {
        sideCard.addEventListener("click", function () {
            renderVideo(sideCard);
            window.history.pushState({}, '', `?video=${sideCard.dataset.videoId}`);
        });
    });



    const selectorsToShowOnlyOnVideoPage = [
        '.section-email-sign-up__wrap',
        '.text--neutral.palette--light.bg--neutral'
    ];

    const selectorsToHideOnVideoPage = [
        '.section-hero',
        '#videoSearch'
    ];

    selectorsToShowOnlyOnVideoPage.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
            el.style.display = activeVideo ? 'flex' : 'none';
        }
    });

    selectorsToHideOnVideoPage.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
            el.style.display = activeVideo ? 'none' : 'flex';
        }
    });

});